import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectItem, ConfirmationService, MessageService } from "primeng/api";
import { DoctorBreadcrumbService } from '../breadcrumb.service';
import { AppointmentService } from "../../../../services/appointment.service";
import { ScheduleService } from "../../../../services/schedule.service";
import { Title } from "@angular/platform-browser";
import {
    appointmentCreate,
    appointmentGetQuery,
    appointmentUpdate,
    getPatientTimingsQuery,
    updateSpeciality,
    AppointmentZoom,
    AssignDoctorModel,
    ReassignDoctorModel,
    RescheduleDoctorModel,
    AppointmentHistory,
    CosnultationHistoryDataQuery,
    GetAvailableDoctorsData,
    Sort_Data,
    APPT_STATUS,
    consent_close
} from "../../../../models/appointment";
import { schedulequery, Schedule, DefaultSlotsQuery, } from "../../../../models/schedule";
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { address, city, dose_input, name_input, number_input, phoneNumber, ROLES, textareaBox, zipCode } from "../../../../constant/constant";
import { DateUtilService, moment_duration } from '../../../../utilities/date.util.service';
import { TraceClassDecorator } from '@sentry/angular';
import { Specialty } from '../../../../models/Speciality';
import { PatientProfileService } from '../../../../services/patient-profile.service';
import { SendProfileLinkService } from '../../../../services/send-profile-link.service';
import { SpecialityService } from '../../../../services/speciality.service';
import { TokenService } from '../../../../utilities/token.service';
import { Router } from '@angular/router';
import { ProviderStateService } from 'src/app/services/provider-state.service';


class DoctoListData {
    speciality_name: string;
    selected_available_doctor_list: SelectItem[];
}

class SlotsDate {
    slot1_primary_from: string;
    slot1_primary_to: string;
    preferred_slot_time: string;
}
class pendingsList extends SlotsDate {
    id: number;
    consultation_type_id: number;
    consultation_id: number;
    patient_guid: string;
    reqno: string;
    date_requested: string;
    patientName: string;
    mrn: string;
    age: string;
    opinion_type: string;
    priority: string;
    speciality: string[];
    communication_type: string;
    documents: string;
    country: string;
    state: string;
    city: string;
    doctor: string;
    doctor_assigned: boolean;
    slot_doctor_choose: boolean;
    preferred_dietician?: string;
    showVendorName: boolean;
    vendorName: string;
}
class assignedPatientList {
    id: number;
    consultation_type_id: number;
    reqno: string;
    date_requested: string;
    patientName: string;
    mrn: string;
    age: string;
    opinion_type: string;
    priority: string;
    speciality: string[];
    communication_type: string;
    documents: string;
    country: string;
    state: string;
    city: string;
    doctor: string[];
    status: string;
    patient_guid: string;
    doctor_user_guid: string[];
    consultation_date: Date;
    consultation_id: number;
    appointments_id: number;
    consultations_left: number;
    close_consent: boolean;
}

class DoctorScheduleData {
    id: number;
    from: string;
    to: string;
}


@TraceClassDecorator()
@Component({
    selector: 'app-appointments',
    templateUrl: './appointments.component.html',
    styleUrls: ['./appointments.component.css'
        , '../../../../../assets/css/custom-egd.css'
    ],
    encapsulation: ViewEncapsulation.None,
    providers: [
        MessageService,
        ConfirmationService,
    ],

})
export class AppointmentsComponent implements OnInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;

    loading: boolean = true;
    loading1: boolean = true;
    loading2: boolean = true;
    loading3: boolean = true;
    loading4: boolean = true;
    selected;
    consultation_id: number;
    close_consent: boolean;
    display: boolean = false;
    update_msg: string = '';
    displayAppointmentModification: boolean = false;
    showVendorName: boolean = false;
    vendorName: string = '';
    is_slot_doctor_choose: boolean = false
    doctor_schedules_data: DoctorScheduleData[] = [];
    current_consultation_id = -1;
    Queryschedule: schedulequery;
    schedules: Schedule[] = [];
    slots_date: SlotsDate;
    roles = ROLES;
    get_Patient_Timings_Query: getPatientTimingsQuery;
    appointment_Create: appointmentCreate;
    my_patients_appointment_Get_Query: appointmentGetQuery = new appointmentGetQuery();
    consent_close: consent_close = new consent_close();
    all_assigned_patients_appointment_Get_Query: appointmentGetQuery;
    appointment_Update: appointmentUpdate;
    doctor_Schedules_query: schedulequery;
    doctor_user_id: string;
    medical_profession_role: number
    ScheduleandZoomDialog: boolean
    current_patient_scheduling_id: Number = -1
    selected_available_doctor: string = null;
    selected_available_doctor_list: SelectItem[] = [];
    selected_doctor_schedule: Schedule = null;
    getDoctorScheduleResult: boolean = false;
    slug: string = "";
    assignDoctorData: AssignDoctorModel = {
        user_guid: [],
        patient_guid: "",
        consultation_id: 0,
        slot_id: 0,
        shouldNotify: true
    };
    reassignDoctorData: ReassignDoctorModel = {
        user_guid: [],
        patient_guid: "",
        consultation_id: 0,
        slot_id: 0,
        reassign_reason: "",
        shouldNotify: true
    };
    rescheduleDoctorData: RescheduleDoctorModel = {
        patient_guid: "",
        consultation_id: 0,
        slot_id: 0,
        reason: "",
        shouldNotify: true
    }
    defaultSchedules: SelectItem[] = [];
    selected_doctor_user_guid: string = "";
    selected_patient_guid: string = "";
    selected_consultation_id: number = -1;
    selected_consultation_type_id: number = -1;
    selected_preferred_dietician: string = null;
    selected_defualt_slot_id: Schedule = null;
    doctor_list_data: DoctoListData[] = [];
    multi_selected_available_doctor = {};
    displayReassign: boolean = false;
    current_reassign_reason = "";
    displayReschedule: boolean = false;
    selected_reschedule_doctor_schedule: Schedule = null;
    current_reschedule_reason = "";
    viewProfileDialog: boolean = false
    medical_conditions;
    textarea_data: any = [];
    members_data;
    view_profile_patient_guid: string = "";
    view_profile_consultation_id: number = -1;
    displayViewProfile: boolean = false
    selected_view_profile_id: number = -1;
    selected_table: string = "";
    doctorAvailabilityResults: boolean = false;
    assignPatients: boolean = false;
    myPatients: boolean = false;
    canellation: boolean = false;
    reassign: boolean = false;
    loader: boolean = false;

    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;


    table_response: PromiseResult;
    table_error: ErrorModel;
    table_serverError: ServerError;
    table_posting: boolean;
    appt_status_select_item: SelectItem[] = [];
    tabs: string[] = [];

    displayDocuments: boolean = false;
    initateLoader: boolean = false;
    currentStatus = "";

    zoom_query: AppointmentZoom = {
        patient_guid: null,
        consultation_id: null,
    }

    showDialog() {
        this.displayDocuments = true;
    }
    Status: SelectItem[] = [
        { label: "Open", value: 1 },
        { label: "In Progress", value: 2 },
        { label: "Closed", value: 3 }
    ];
    TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly messageService: MessageService,
        private readonly appointmentService: AppointmentService,
        private readonly scheduleService: ScheduleService,
        private readonly specialtyservice: SpecialityService,
        private readonly patientProfileService: PatientProfileService,
        private readonly shareLink: SendProfileLinkService,
        private readonly titleService: Title,
        private readonly dateUtil: DateUtilService,
        private readonly tokenUtil: TokenService,
        private readonly router: Router,
        private readonly providerstateService: ProviderStateService

    ) {


        this.appt_status_select_item = Object.values(APPT_STATUS).map(val => {
            return { label: val, value: val }
        })
        this.appt_status_select_item.unshift({ label: 'Active', value: null });
        this.roles = ROLES;
    }

    pending_list_columns = [
        'id',
        'reqno',
        'date_requested',
        'patientName',
        'mrn',
        'age',
        'opinion_type',
        'priority',
        'speciality',
        'communication_type',
        'documents',
        'country',
        'state',
        'city',
        'doctor',
        'doctor_assigned',
    ];
    consultation_type_id = 0;

    assigned_patient_columns = [
        'reqno ',
        'date_requested ',
        'patientName ',
        'mrn ',
        'age ',
        'opinion_type ',
        'priority ',
        'speciality ',
        'communication_type ',
        'documents ',
        'country',
        'state',
        'city',
        'doctor',
        'status',
    ];


    pendings_list: pendingsList[] = [];
    my_patients: assignedPatientList[] = [];

    all_assigned_patients: assignedPatientList[] = [];
    share_dialog: boolean = false;
    join_zoom_url_for_attendee: string = "";
    patient_profile_link: string = "";
    message: string = "";
    base: string = "";
    share_loader: boolean = false;

    specialities: Specialty[] = [];
    selectedSpeciality: Specialty[] = [];

    changeSpeciality_dialog: boolean = false;
    updateSpeciality_data: updateSpeciality;
    historyDialog: boolean = false;

    history_response: PromiseResult;
    history_serverError: ServerError;
    history_posting: boolean;
    history_error: ErrorModel;
    history: AppointmentHistory;
    provider_id: string = "";
    sort: Sort_Data = new Sort_Data(
        [
            {
                label: "Ascending",
                value: "ASC"
            },
            {
                label: "Descending",
                value: "DESC"
            }
        ],
        "DESC"
    );
    show_specialty_change: boolean = true;

    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Appointments");
        this.slug = this.providerstateService.getProviderSlug();
        this.provider_id = this.providerstateService.getProviderId();
        this.breadcrumbService.setItems([
            {
                label: 'Dashboard', routerLink: [`/${this.slug}/doctor`]
            },
            { label: 'Appointments' }
        ]);
        this.base = window.location.origin;
        this.doctor_user_id = sessionStorage.getItem('userid');
        this.medical_profession_role = this.tokenUtil.findRoleId();
        await this.ResetResultModels();
        await this.ResetResultTableModels();
        this.loader = true;
        this.posting = false;
        await this.getAppointmetScreen();
        this.my_patients_appointment_Get_Query = {
            user_guid: this.doctor_user_id,
            self: true,
            fromtime: null,
            totime: null
        };

        this.all_assigned_patients_appointment_Get_Query = {
            user_guid: this.doctor_user_id,
            self: false,
            fromtime: null,
            totime: null
        };

        this.updateSpeciality_data = {
            patient_guid: null,
            consultation_id: null,
            specialty_id: []
        };
        if (this.medical_profession_role == ROLES.Support)
            this.show_specialty_change = false;
        await this.getSpecialty(this.provider_id);

        this.displayAppointmentModification = false;
        this.displayReassign = false;
        this.displayReschedule = false;
        // await this.getPendingListData();
        // await this.getMyPatientsListData();
        // await this.getAllAssignedPatientsListData();

    }
    async getSpecialty(provider_id?: string) {
        await this.specialtyservice.GetAllSupported(undefined, provider_id).toPromise()
            .then(result => {
                this.specialities = result.data;
            })
    }
    changeSpecility(my_patients_row: pendingsList) {
        this.changeSpeciality_dialog = true;
        this.updateSpeciality_data = {
            patient_guid: my_patients_row.patient_guid,
            consultation_id: my_patients_row.consultation_id,
            specialty_id: [],
        }
    }

    closeChangeSpecility() {
        this.changeSpeciality_dialog = false;
        this.posting = false;
        this.selectedSpeciality = null;
        this.updateSpeciality_data = {
            patient_guid: null,
            consultation_id: null,
            specialty_id: [],
        }
    }

    async updateSpecilaity() {
        await this.ResetResultModels()
        this.posting = true;
        this.updateSpeciality_data.specialty_id = this.selectedSpeciality.map(sp => { return sp.id });
        this.appointmentService.updateSpecialty(this.updateSpeciality_data).toPromise().then(async result => {
            this.response = result;
            if (result.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "The patient's specialty has been updated successfully",
                });
                this.closeChangeSpecility();
                await this.getPendingListData();
            }
            else if (!this.response.success) {
                this.error = result.error;
            }
            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });;

    }

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    private async ResetResultTableModels(): Promise<void> {
        this.table_response = {
            success: null,
            error: null,
            data: null
        };
        this.table_serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    getTabs(): string[] {
        let tabs: string[] = [];
        if (this.assignPatients) {
            tabs.push("assignPatients")
        }
        if (this.myPatients) {
            tabs.push("myPatients");
        }
        if (this.reassign) {
            tabs.push("reassign");
        }
        return tabs
    }

    async getAppointmetScreen() {

        if (this.medical_profession_role == ROLES.Doctor) {
            this.assignPatients = false;
            this.myPatients = true;
            this.reassign = false;
            this.tabs = this.getTabs();
            await this.getMyPatientsListData();
        }
        else if (this.medical_profession_role == ROLES.Admin) {
            this.assignPatients = true;
            this.myPatients = true;
            this.reassign = true;
            this.tabs = this.getTabs();
            await this.getPendingListData();
        }
        else if (this.medical_profession_role == ROLES.SuperAdmin) {
            this.assignPatients = true;
            this.myPatients = true;
            this.reassign = true;
            this.tabs = this.getTabs();
            await this.getPendingListData();
        }
        else if (this.medical_profession_role == ROLES.SuperAdmin_Doctor) {
            this.assignPatients = true;
            this.myPatients = true;
            this.reassign = true;
            this.tabs = this.getTabs();
            await this.getPendingListData();
        }
        else if (this.medical_profession_role == ROLES.Admin_Doctor) {
            this.assignPatients = true;
            this.myPatients = true;
            this.reassign = true;
            this.tabs = this.getTabs();
            await this.getPendingListData();
        }
        else if (this.medical_profession_role == ROLES.Other_Medical_Professional) {
            this.assignPatients = false;
            this.myPatients = true;
            this.reassign = false;
            this.tabs = this.getTabs();
            await this.getMyPatientsListData();
        }
        else if (this.medical_profession_role == ROLES.Other_Medical_Professional_Admin) {
            this.assignPatients = true;
            this.myPatients = false;
            this.reassign = true;
            this.tabs = this.getTabs();
            await this.getPendingListData();
        }
        else if (this.medical_profession_role == ROLES.Support) {
            this.assignPatients = true;
            this.myPatients = false;
            this.reassign = true;
            this.tabs = this.getTabs();
            await this.getPendingListData();
        }
        this.loader = false;
    }

    async onTabChange(event: any) {
        await this.ResetResultModels();
        await this.ResetResultTableModels();
        // await this.ResetResultInitateModels();
        if (this.tabs[event.index] == "assignPatients" && this.assignPatients == true) {
            await this.getPendingListData();
        }
        else if (this.tabs[event.index] == "myPatients" && this.myPatients == true) {
            await this.getMyPatientsListData();
        }
        else if (this.tabs[event.index] == "reassign" && this.reassign == true) {
            await this.getAllAssignedPatientsListData();
        }
    }

    async assign_doctor() {
        this.assignDoctorData = {
            patient_guid: this.selected_patient_guid,
            user_guid: Object.values(this.multi_selected_available_doctor),
            consultation_id: Number(this.selected_consultation_id),
            slot_id: Number(this.selected_defualt_slot_id.slot_id),
            shouldNotify: this.assignDoctorData.shouldNotify
        }
        await this.ResetResultModels();
        this.posting = true;

        await this.appointmentService.Assign(this.assignDoctorData)
            .toPromise()
            .then(async result => {
                this.response = result;

                if (this.response.success) {
                    // this.pendings_list[id].doctor_assigned = true;
                    // this.pendings_list[id].doctor = this.selected_available_doctor.name;
                    this.assignDoctorData = {
                        user_guid: [],
                        patient_guid: "",
                        consultation_id: 0,
                        slot_id: 0,
                        shouldNotify: true
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "The patient has been assigned successfully",
                    });
                    this.closeAssignDoctor();
                }
                else if (!this.response.success) {
                    this.error = result.error;
                }

                this.posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
        await this.getPendingListData();
        // await this.getMyPatientsListData();
        // await this.getAllAssignedPatientsListData()

    }

    async reassign_doctor() {
        this.reassignDoctorData = {
            patient_guid: this.selected_patient_guid,
            user_guid: Object.values(this.multi_selected_available_doctor),
            consultation_id: Number(this.selected_consultation_id),
            slot_id: Number(this.selected_defualt_slot_id.slot_id),
            reassign_reason: this.current_reassign_reason,
            shouldNotify: this.reassignDoctorData.shouldNotify
        }
        await this.ResetResultModels();
        this.posting = true;
        await this.appointmentService.Reassign(this.reassignDoctorData).toPromise().then(result => {

            this.response = result;
            if (this.response.success) {
                this.reassignDoctorData = {
                    user_guid: [],
                    patient_guid: "",
                    consultation_id: 0,
                    slot_id: 0,
                    reassign_reason: "",
                    shouldNotify: true
                }
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "The patient has been reassigned successfully",
                });
                this.displayReassign = false;
            }
            else if (!this.response.success) {
                this.error = result.error;
            }

            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        // await this.getPendingListData();
        // await this.getMyPatientsListData();
        await this.getAllAssignedPatientsListData()

    }

    async reschedule_doctor() {
        await this.ResetResultModels();
        this.posting = true;
        this.rescheduleDoctorData.patient_guid = this.selected_patient_guid;
        this.rescheduleDoctorData.consultation_id = this.selected_consultation_id;;
        this.rescheduleDoctorData.reason = this.current_reschedule_reason;
        this.rescheduleDoctorData.slot_id = this.selected_reschedule_doctor_schedule.slot_id;
        await this.appointmentService.Reschedule(this.rescheduleDoctorData).toPromise().then(result => {
            this.response = result;
            if (this.response.success) {
                this.rescheduleDoctorData = {
                    patient_guid: "",
                    consultation_id: 0,
                    slot_id: 0,
                    reason: "",
                    shouldNotify: true
                }
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "The patient has been rescheduled successfully",
                });
                this.displayReschedule = false;
            }
            else if (!this.response.success) {
                this.error = result.error;
            }

            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        // await this.getPendingListData();
        // await this.getMyPatientsListData();
        await this.getAllAssignedPatientsListData()

    }

    async getMyPatientsListData() {
        await this.ResetResultTableModels();
        this.loading1 = true;
        // this.my_patients_appointment_Get_Query = {
        //     user_guid: this.doctor_user_id,
        //     self: true,
        //     fromtime: null,
        //     totime: null,
        // };
        this.my_patients_appointment_Get_Query.user_guid = this.doctor_user_id;
        this.my_patients_appointment_Get_Query.self = true;
        this.my_patients_appointment_Get_Query.fromtime = null;
        this.my_patients_appointment_Get_Query.totime = null;
        await this.appointmentService.GetAllMyAssignedPatients(this.my_patients_appointment_Get_Query).toPromise().then(result => {

            this.table_response = result;
            if (this.table_response.success) {
                let temp: assignedPatientList[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    let my_patients_obj: assignedPatientList = {
                        id: i + 1,
                        consultation_type_id: result.data[i].consultation_type_id,
                        reqno: result.data[i].consultation_request_number,
                        date_requested: result.data[i].created_at,
                        patientName: result.data[i].accounts.first_name + " " + (result.data[i].accounts.middle_name == null ? '' : result.data[i].accounts.middle_name) + " " + result.data[i].accounts.last_name,
                        mrn: result.data[i].accounts.medical_record_number,
                        age: this.dateUtil.diff(result.data[i].accounts.date_of_birth, new Date(), moment_duration.years) + ' Yrs',
                        opinion_type: result.data[i].priority_type.consultation_name,
                        priority: result.data[i].priority_type.priority_type,
                        speciality: result.data[i].p_consultation_appointment.map(d => { return d.d_specialty_type.specialty_name }),
                        communication_type: result.data[i].communication_type.communication_name,
                        documents: 'www.google.com',
                        country: result.data[i].accounts.country.country_name,
                        state: result.data[i].accounts.state_name,
                        city: result.data[i].accounts.city,
                        status: result.data[i].consultation_status,
                        patient_guid: result.data[i].patient_guid,
                        consultation_date: result.data[i].consultation_date,
                        close_consent: result.data[i].close_consent,
                        doctor_user_guid: result.data[i].p_consultation_appointment.map(d => {
                            return d.egd_users.user_guid
                        }),
                        consultation_id: Number(result.data[i].id),
                        appointments_id: (result.data[i].p_appointments != null) ? Number(result.data[i].p_appointments.id) : null,
                        doctor: result.data[i].p_consultation_appointment.map(d => {
                            return d.egd_users.first_name + ' ' + (d.egd_users.middle_name == null ? '' : d.egd_users.middle_name) + ' ' + d.egd_users.last_name
                        }),
                        consultations_left: result.data[i].consultations_left
                    }
                    temp.push(my_patients_obj)
                }
                this.my_patients = temp;
            }
            else if (!this.table_response.success) {
                this.table_error = result.error;
            }
            this.loading1 = false;
        }).catch((error: HttpErrorResponse) => {
            this.table_serverError = error.error;
            this.table_response.success = false;
            this.loading1 = false;
        });

    }

    async getAllAssignedPatientsListData() {
        await this.ResetResultTableModels();
        this.loading4 = true;
        await this.appointmentService.GetAllMyAssignedPatients(this.all_assigned_patients_appointment_Get_Query).toPromise().then(result => {

            this.table_response = result;
            if (this.table_response.success) {
                let temp: assignedPatientList[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    let all_patients_obj: assignedPatientList = {
                        id: i + 1,
                        consultation_type_id: result.data[i].consultation_type_id,
                        reqno: result.data[i].consultation_request_number,
                        date_requested: result.data[i].created_at,
                        patientName: result.data[i].accounts.first_name + " " + (result.data[i].accounts.middle_name == null ? '' : result.data[i].accounts.middle_name) + " " + result.data[i].accounts.last_name,
                        mrn: result.data[i].accounts.medical_record_number,
                        age: this.dateUtil.diff(result.data[i].accounts.date_of_birth, new Date(), moment_duration.years) + ' Yrs',
                        opinion_type: result.data[i].priority_type.consultation_name,
                        priority: result.data[i].priority_type.priority_type,
                        speciality: result.data[i].p_consultation_appointment.map(d => { return d.d_specialty_type.specialty_name }),
                        communication_type: result.data[i].communication_type.communication_name,
                        documents: 'www.google.com',
                        country: result.data[i].accounts.country.country_name,
                        state: result.data[i].accounts.state_name,
                        city: result.data[i].accounts.city,
                        status: result.data[i].consultation_status,
                        consultation_date: result.data[i].consultation_date,
                        patient_guid: result.data[i].patient_guid,
                        doctor_user_guid: result.data[i].p_consultation_appointment.map(d => {
                            return d.egd_users.user_guid
                        }),
                        consultation_id: Number(result.data[i].id),
                        appointments_id: (result.data[i].p_appointments != null) ? Number(result.data[i].p_appointments.id) : null,
                        doctor: result.data[i].p_consultation_appointment.map(d => {
                            return d.egd_users.first_name + ' ' + (d.egd_users.middle_name == null ? '' : d.egd_users.middle_name) + ' ' + d.egd_users.last_name
                        }),
                        consultations_left: result.data[i].consultations_left,
                        close_consent: result.data[i].consent_update
                    }
                    temp.push(all_patients_obj)
                }
                this.all_assigned_patients = temp;
            }
            else if (!this.table_response.success) {
                this.table_error = result.error;
            }
            this.loading4 = false;
        }).catch((error: HttpErrorResponse) => {
            this.table_serverError = error.error;
            this.table_response.success = false;
            this.loading4 = false;
        });

    }


    reloadPage() {
        window.location.reload();
    }

    async open_view_profile(table: string, patient_guid: string, consultation_id: number) {
        this.view_profile_patient_guid = patient_guid;
        this.view_profile_consultation_id = consultation_id;
        this.viewProfileDialog = true

    }


    close_view_profile() {
        this.viewProfileDialog = false;

        this.view_profile_patient_guid = "";
        this.view_profile_consultation_id = -1;

    }

    async open_patient_view(patient_guid: string, consultation_id: number) {
        this.router.navigate(['/' + this.slug + '/doctor/appointments/patient-view/', patient_guid, consultation_id]);
    }

    async open_assign_Doctor_Modal(patient: pendingsList) {
        this.selected_consultation_type_id = patient.consultation_type_id;
        this.selected_preferred_dietician = patient.preferred_dietician;
        this.selected_patient_guid = patient.patient_guid;
        this.selected_consultation_id = patient.consultation_id;
        this.is_slot_doctor_choose = patient.slot_doctor_choose;
        this.slots_date = {
            slot1_primary_from: this.dateUtil.getSlotTime(patient.slot1_primary_from),
            slot1_primary_to: this.dateUtil.getSlotTime(patient.slot1_primary_to),
            preferred_slot_time: this.dateUtil.getSlotTime(patient.preferred_slot_time),
        };
        this.selected_defualt_slot_id = null;
        this.doctor_list_data = [];
        this.multi_selected_available_doctor = {};
        this.selected_doctor_schedule = null;
        this.selected_available_doctor_list = [];
        this.schedules = [];
        this.selected_available_doctor = null;
        this.getDoctorScheduleResult = false;
        this.displayAppointmentModification = true;
        this.showVendorName = patient.showVendorName;
        this.vendorName = patient.vendorName;
        this.doctorAvailabilityResults = false;
        await this.getDefaultsTimings(patient.patient_guid, patient.consultation_id);

    }

    closeAssignDoctor() {
        //for this.displayAppointmentModification
        this.displayAppointmentModification = false;
        this.selected_available_doctor = null;
        this.selected_preferred_dietician = null;
        this.selected_doctor_schedule = null;
        this.selected_available_doctor_list = [];
        this.schedules = [];
        this.getDoctorScheduleResult = false;
        this.selected_patient_guid = "";
        this.selected_consultation_id = -1;
        this.selected_doctor_user_guid = "";
        this.doctorAvailabilityResults = false;
        this.selected_consultation_type_id = -1;
        this.selected_defualt_slot_id = null;
        this.doctor_list_data = [];
        this.multi_selected_available_doctor = {};
        this.assignDoctorData.shouldNotify = true;
        this.showVendorName = false;
        this.vendorName = '';
    }

    async open_reassign_modal(patient: assignedPatientList) {
        this.selected_consultation_type_id = patient.consultation_type_id;
        this.selected_patient_guid = patient.patient_guid;
        this.selected_consultation_id = patient.consultation_id;
        // this.selected_doctor_user_guid = patient.user_guid;
        this.selected_defualt_slot_id = null;
        this.doctor_list_data = [];
        this.multi_selected_available_doctor = {};
        this.current_reassign_reason = "";
        this.selected_available_doctor = null;
        this.selected_doctor_schedule = null;
        this.selected_available_doctor_list = [];
        this.getDoctorScheduleResult = false;
        this.doctorAvailabilityResults = false;
        this.schedules = [];
        this.displayReassign = true;
        await this.getDefaultsTimings(patient.patient_guid, patient.consultation_id);


    }

    closeReassignDoctor() {
        //for this.displayReassign
        this.displayReassign = false;
        this.selected_available_doctor = null;
        this.selected_doctor_schedule = null;
        this.selected_available_doctor_list = [];
        this.schedules = []
        this.getDoctorScheduleResult = false;
        this.selected_patient_guid = "";
        this.selected_consultation_id = -1;
        this.selected_doctor_user_guid = "";
        this.current_reassign_reason = "";
        this.selected_consultation_type_id = -1;
        this.selected_defualt_slot_id = null;
        this.doctor_list_data = [];
        this.multi_selected_available_doctor = {};
        this.doctorAvailabilityResults = false;
        this.reassignDoctorData.shouldNotify = true;
    }

    async open_reschedule_modal(patient: assignedPatientList) {
        this.selected_patient_guid = patient.patient_guid;
        this.selected_consultation_id = patient.consultation_id;
        this.selected_consultation_type_id = patient.consultation_type_id;
        const query = new DefaultSlotsQuery();
        query.reschedule = true;
        await this.getDefaultsTimings(patient.patient_guid, patient.consultation_id, query);
        this.current_reschedule_reason = "";
        this.selected_reschedule_doctor_schedule = null;
        this.consultation_type_id = patient.consultation_type_id;
        this.displayReschedule = true;

    }

    closeRescheduleDoctor() {
        //for this.displayReschedule
        this.displayReschedule = false;
        this.selected_reschedule_doctor_schedule = null;
        this.schedules = []
        this.getDoctorScheduleResult = false;
        this.selected_patient_guid = "";
        this.selected_consultation_id = -1;
        this.current_reschedule_reason;
        this.rescheduleDoctorData.shouldNotify = true;
    }

    createDoctorDropdownList(doctor_data) {
        let temp: SelectItem[] = [];
        let doc: SelectItem = { label: 'Select a Doctor', value: null };
        // temp.push(doc);
        for (const doctor of doctor_data) {
            doc = {
                label: doctor.first_name
                    + ' ' + (doctor.middle_name == null ? '' : doctor.middle_name)
                    + ' ' + doctor.last_name,
                value: doctor.user_guid
            }
            temp.push(doc);
        }

        return temp
    }

    getMultiSpecialtyDropdownFilledBoolean() {
        let no_of_sepcialties = Object.keys(this.multi_selected_available_doctor).length;
        let is_null = false;
        for (let index = 0; index < no_of_sepcialties; index++) {
            is_null = this.multi_selected_available_doctor[index] == null;
            if (is_null) {
                break;
            }
        }
        return !is_null;
    }

    getDisabledConditionBoolean(name: string) {
        if (name == "ASSIGN") {
            let is_null = !this.getMultiSpecialtyDropdownFilledBoolean();
            return (is_null || this.selected_defualt_slot_id == null) || this.posting == true;
        }
        else if (name = "REASSIGN") {
            let is_null = !this.getMultiSpecialtyDropdownFilledBoolean();
            return (is_null || this.selected_defualt_slot_id == null || this.current_reassign_reason.length == 0) || this.posting == true;
        }
    }

    async GetAvailableDoctors(patient_guid: string, consultation_id: number, slot_id: Schedule) {
        await this.ResetResultModels();
        this.doctorAvailabilityResults = false;
        this.selected_available_doctor_list = [];
        this.doctor_list_data = []
        let getAvailableDoctors: GetAvailableDoctorsData = {
            consultation_id: consultation_id,
            patient_guid: patient_guid,
            slot_id: slot_id.slot_id
        }
        await this.scheduleService.GetAllAvailableDoctors(getAvailableDoctors).toPromise().then(result => {

            this.response = result;
            if (this.response.success) {
                let result_consultation_type_id = result.data.consultation_type_id;
                this.selected_consultation_type_id = result_consultation_type_id;

                this.doctor_list_data = [];
                let temp_doctor_list_data: DoctoListData[] = [];
                let i = 0;
                for (const multi_specialty_data of result.data.data) {
                    let temp_mult_specialty_data: DoctoListData = {
                        speciality_name: multi_specialty_data.specialty_name,
                        selected_available_doctor_list: this.createDoctorDropdownList(multi_specialty_data.data)
                    }
                    this.multi_selected_available_doctor[i++] = null;
                    temp_doctor_list_data.push(temp_mult_specialty_data);
                }
                this.doctor_list_data = temp_doctor_list_data;
                this.doctorAvailabilityResults = true;


            }
            else if (!this.response.success) {
                this.error = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            // this.posting=false;
        });
    }

    async getPendingListData() {
        await this.ResetResultTableModels();
        this.loading = true;
        await this.appointmentService.GetAllUnassignedPatients(this.sort).toPromise().then(result => {

            this.table_response = result;
            if (this.table_response.success) {
                let temp: pendingsList[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    let pending_list_obj: pendingsList = {
                        id: i + 1,
                        consultation_type_id: result.data[i].consultation_type_id,
                        consultation_id: result.data[i].id,
                        patient_guid: result.data[i].patient_guid,
                        reqno: result.data[i].consultation_request_number,
                        date_requested: result.data[i].created_at,
                        patientName: result.data[i].accounts.first_name + " " + (result.data[i].accounts.middle_name == null ? '' : result.data[i].accounts.middle_name) + " " + result.data[i].accounts.last_name,
                        mrn: result.data[i].accounts.medical_record_number,
                        age: this.dateUtil.diff(result.data[i].accounts.date_of_birth, new Date(), moment_duration.years) + ' Yrs',
                        opinion_type: result.data[i].priority_type.consultation_name,
                        priority: result.data[i].priority_type.priority_type,
                        speciality: result.data[i].p_consultation_appointment.map(d => { return d.d_specialty_type.specialty_name }),
                        communication_type: result.data[i].communication_type.communication_name,
                        documents: 'www.google.com',
                        country: result.data[i].accounts.country.country_name,
                        state: result.data[i].accounts.state_name,
                        city: result.data[i].accounts.city,
                        doctor: null,
                        doctor_assigned: false,
                        slot1_primary_from: result.data[i].slot1_primary_from,
                        slot1_primary_to: result.data[i].slot1_primary_to,
                        slot_doctor_choose: result.data[i].slot_doctor_choose,
                        preferred_dietician: result.data[i].diet_consultation_data && result.data[i].consultation_type_id == 5 && result.data[i].diet_consultation_data.egd_users ? (result.data[i].diet_consultation_data.egd_users.first_name + ' ' + result.data[i].diet_consultation_data.egd_users.last_name) : null,
                        preferred_slot_time: result.data[i].preferred_slot?.slot_time || null,
                        showVendorName: result.data[i].vendor_guid != null,
                        vendorName: result.data[i].egd_vendors?.vendor_name || '',
                    }
                    temp.push(pending_list_obj)
                }
                this.pendings_list = temp;
            }
            else if (!this.table_response.success) {
                this.table_error = result.error;
            }
            this.loading = false;

        }).catch((error: HttpErrorResponse) => {
            this.table_serverError = error.error;
            this.table_response.success = false;
            this.loading = false;
        });

    }

    async getDefaultsTimings(patient_guid: string, consultation_id: number, query?: DefaultSlotsQuery) {
        // if (this.selected_available_doctor != null) {
        this.selected_doctor_schedule = null;
        this.getDoctorScheduleResult = false;
        await this.ResetResultModels();
        this.schedules = []
        await this.scheduleService.fetchDefault({
            patient_guid, consultation_id
        }, query).toPromise().then(result => {
            this.response = result;

            if (this.response.success) {
                if (!result.success) this.error = result.error;
                let schedules_result = result.data.slots;
                let temp_schedules: Schedule[] = [];

                this.getDoctorScheduleResult = result.success;
                for (let i = 0; i < schedules_result.length; i++) {
                    //  id: 38, slot_time: "2021-01-29T00:00:00.000Z", status: false
                    // if (schedules_result[i].status == false) {
                    let a = new Date(schedules_result[i].slot_time).toDateString();
                    let b = new Date(schedules_result[i].slot_time).toLocaleString().split(",")[1];
                    let temp: Schedule = {
                        sr_no: i,
                        slot_id: schedules_result[i].slot_id,
                        slot_time: schedules_result[i].slot_time,
                        status: false,
                        date: a + b,
                        block: false,
                    }
                    temp_schedules.push(temp);
                    // }
                }

                this.schedules = temp_schedules;
            }
            else if (!this.response.success) {
                this.error = result.error;
            }

        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            // this.posting=false;
        });

    }

    async onChangeDefaultTimings() {
        await this.GetAvailableDoctors(this.selected_patient_guid, this.selected_consultation_id, this.selected_defualt_slot_id);
    }
    async getPatientTimings() {
        this.get_Patient_Timings_Query = {
            patient_guid: this.selected_patient_guid,
            user_guid: this.selected_doctor_user_guid,
            consultation_id: this.selected_consultation_id
        }

        // await this.appointmentService.GetPatientTimings(this.get_Patient_Timings_Query).toPromise().then(result => {
        //   
        //     // this.temp_result=result;
        //     if (result.success) {
        //         this.is_slot_doctor_choose = boolean(!result.data.slot_doctor_choose)
        //         this.slots_date = result.data.time;
        //         
        //     }
        // });
    }


    async onCloseInitateDialog() {
        //clearing the values and getting the dataable refreshed
        this.selected_patient_guid = "";
        this.selected_doctor_user_guid = "";
        this.selected_consultation_id = -1;
        this.currentStatus = "";
        // await this.closeInitate();
        await this.ResetResultModels();
        // await this.ResetResultInitateModels();
        // await this.getMyPatientsListData();

    }

    async getConsultationsHistoryData(data: assignedPatientList) {
        this.history_posting = true;
        let history_query_data: CosnultationHistoryDataQuery = {
            patient_guid: data.patient_guid,
            user_guid: this.doctor_user_id,
            consultation_id: data.consultation_id,
        }

        await this.appointmentService.getCosnultationHistory(history_query_data).toPromise().then(result => {
            this.history_response = result;

            if (result.success) {
                this.history = result.data;
                this.historyDialog = true;

            }
            else if (!this.history_response.success) {
                this.history_error = result.error;
            }
            this.history_posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.history_serverError = error.error;
            this.history_response.success = false;
            this.history_posting = false;
        });
    }



    async open_share(consultation_id: number, patient_guid: string, user_guid: string) {
        this.message = "";
        this.share_loader = true;
        await this.ResetResultModels();
        this.zoom_query = { patient_guid: patient_guid, consultation_id: consultation_id };
        await this.appointmentService.ZoomAppointmentUrl(user_guid, this.zoom_query).toPromise().then(async result => {
            this.response = result;

            if (result.success) {
                this.join_zoom_url_for_attendee = result.data.join_url;
                // this.patient_profile_link=this.base+"/"+"doctor/patientProfile/"+patient_guid+"/"+consultation_id;

                this.message = this.join_zoom_url_for_attendee;
                // this.initate_response = result;
                // if (this.initate_response.success) {
                //     this.join_zoom = result.data.start_url;
                //     this.initateLoader = false;
                //     if (this.join_zoom?.length > 0) {
                //         window.open(this.join_zoom, '_blank');
                //     }
                // }
                // else if (!this.initate_response.success) {
                //     this.error = result.error;
                // }
                // this.initateLoader = false;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            // this.initateLoader = false;
        });
        this.share_dialog = true;
        this.share_loader = false;
    }

    closeShareDialog() {
        this.share_dialog = false;
    }
    closeShare(closeDialog) {
        if ((Boolean(closeDialog))) {
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Your message has been sent",
            });
        }
        this.share_dialog = !(Boolean(closeDialog));
    }

    async getToken(doctor_guid) {
        if (doctor_guid != null) {
            await this.ResetResultModels();
            let temp = new Date();
            temp.setDate(new Date().getDate() + 35);
            let validTillDate = temp;
            let data_queryGenrateToken = {
                user_guid: doctor_guid,
                patient_guid: this.zoom_query.patient_guid,
                valid_till: validTillDate
            }
            await this.patientProfileService.GenrateToken(data_queryGenrateToken)
                .toPromise()
                .then(result => {
                    this.response = result;

                    if (result.success) {
                        // this.join_zoom_url_for_attendee=result.data.join_url;
                        this.patient_profile_link = result.data.link
                        this.shareLink.setProfileLink(result.data.link);

                        // this.message=this.join_zoom_url_for_attendee+"\n"+this.patient_profile_link;

                    }
                })
        }
    }
    showDialog1(my_patients: any) {
        this.display = true;
        this.update_msg = '';
        this.close_consent = my_patients.close_consent;
        this.consultation_id = my_patients.consultation_id;
    }
    async updateConsent() {
        this.consent_close = {
            close_consent: this.close_consent
        }
        await this.appointmentService
            .UpdateConsent(this.consultation_id, this.consent_close)
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.update_msg = "Consent Updated successfully";
                    this.getMyPatientsListData();
                    this.display = false;
                }
                else {
                    this.update_msg = result.error.message;
                    // console.log(this.update_msg,"checking2");
                }

            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.update_msg = error.error.message;
                // this.initateLoader = false;
            });

    }
}
